// extracted by mini-css-extract-plugin
export default {"list":"ProductCardBadges_list__w9rOd","badges":"ProductCardBadges_badges__vEVnm"};